<script lang="ts">
	import Minus from '../icons/minus.svelte';
	import type { AccordionTheme } from './types';
	import type { Snippet } from 'svelte';
	interface Props {
		title: string;
		open?: boolean;
		border?: boolean;
		theme?: AccordionTheme;
		ontoggle?: (open: boolean) => void;
		class?: string;
		children?: Snippet;
	}

	let {
		title,
		open = false,
		border = false,
		theme = 'lime',
		class: className,
		ontoggle,
		children
	}: Props = $props();

	let contentHeight = $state(0);
	let contentWidth = $state(0);

	let brownTheme = $derived(['brown', 'full-brown'].includes(theme));
</script>

<div
	bind:clientHeight={contentHeight}
	style="width: {contentWidth}px"
	class="invisible absolute -top-full {className || ''}"
>
	{@render children?.()}
</div>

<div
	class={[
		'py-6',
		{
			'border-b': border,
			'border-b-stone-4': border && !brownTheme,
			'border-b-brown-2': border && theme === 'brown',
			'border-b-stone-3': border && theme === 'full-brown'
		}
	]}
	aria-describedby="accordion"
>
	<button
		aria-controls="accordion"
		aria-expanded={open}
		type="button"
		class="flex w-full items-center justify-between gap-x-2 font-semibold"
		onclick={() => {
			open = !open;
			ontoggle?.(open);
		}}
	>
		<span
			class={[
				'flex-1 text-left text-desktop-h6',
				{
					'text-stone-4': !brownTheme,
					'text-brown-2': brownTheme,
					'font-semibold': ['lime', 'brown', 'full-brown'].includes(theme)
				}
			]}
		>
			{title}
		</span>

		<span
			class={[
				'relative h-10 w-10',
				{
					'text-green-5': theme === 'lime',
					'text-stone-4': theme === 'stone',
					'text-purple-3': theme === 'brown',
					'text-brown-2': theme === 'full-brown'
				}
			]}
		>
			<Minus class="absolute inset-0" />
			<Minus
				class={[
					'absolute inset-0 transform-gpu transition-transform duration-300',
					{ 'rotate-90': !open }
				]}
			/>
		</span>
	</button>

	<div
		style="max-height: {open ? contentHeight : 0}px"
		bind:clientWidth={contentWidth}
		class={[
			'transform-gpu overflow-hidden transition-all duration-300 ease-in-out',
			className,
			{
				'translate-y-4': open,
				'pb-8': open,
				'opacity-0': !open,
				'opacity-100': open
			}
		]}
	>
		{@render children?.()}
	</div>
</div>
